import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant, truncateText } from "@similarweb/styles";
import { Autocomplete, ItemIcon, PopoverContent } from "@similarweb/ui-components";

import { aiAgentColors } from "app/pages/sales-intelligence/modules/ai-agent/components";

export const StyledItemsContainer = styled.div<{ withScrollbar: boolean; maxItemsToShow: number }>`
    max-height: ${({ maxItemsToShow }) => `${maxItemsToShow * 48}px`};
    overflow-y: auto;
    margin-right: ${({ withScrollbar }) => (withScrollbar ? "2px" : 0)};
    border-radius: 18px;

    &::-webkit-scrollbar {
        width: 7px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${colorsPalettes.carbon[200]};
        border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background: ${colorsPalettes.carbon[0]};
        margin: 12px 0;
    }
`;

export const StyledCompanyAutocomplete = styled(Autocomplete)<{ disabled?: boolean }>`
    width: 100%;
    height: 42px;
    margin-top: 46px;

    &::before {
        content: "";
        position: absolute;
        inset: 0;
        padding: 2px;
        border-radius: 50px;
        background: ${({ disabled }) =>
            disabled
                ? "none"
                : `linear-gradient(
            90deg,
            ${aiAgentColors.gradient.blue} 1%,
            ${aiAgentColors.gradient.lightBlue} 73%,
            ${aiAgentColors.gradient.green} 100%
        )`};
    }

    .AutoCompleteContainer {
        transform: none;
        padding: 0;
        background: ${({ disabled }) => (disabled ? colorsPalettes.carbon[25] : "transparent")};
        border-radius: 50px;
        border: 1px solid ${({ disabled }) => (disabled ? colorsPalettes.carbon[100] : "transparent")};
        box-shadow: none;
    }

    .input-container {
        border-radius: 50px;
        background: ${({ disabled }) => (disabled ? colorsPalettes.carbon[25] : colorsPalettes.carbon[0])};

        input {
            padding: 12px 36px 12px 0;
        }
    }

    .ListItemsContainer {
        position: relative;
        border-radius: 20px !important;
        transform: translate(0, 10px);

        &::before {
            display: none;
        }
    }
`;

export const StyledCompanyPlaceholderText = styled.span`
    margin-left: 0;
`;

export const StyledAutocompleteTrigger = styled.div<{ isVisible: boolean; isDisabled?: boolean }>`
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    display: flex;
    background: ${({ isDisabled }) => (isDisabled ? colorsPalettes.bluegrey[200] : colorsPalettes.carbon[0])};
    align-items: center;
    padding: 12px 12px;
    gap: 8px;
    border: 1px solid ${colorsPalettes.midnight[50]};
    border-radius: 3px;
    visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
    pointer-events: ${({ isVisible }) => (isVisible ? "auto" : "none")};
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};

    ${({ isDisabled }) =>
        !isDisabled &&
        css`
            &:hover {
                box-shadow: rgba(42, 62, 82, 0.12) 0px 3px 5px 0px;
            }
        `}
`;

export const StyledAutocompleteTriggerText = styled.span<{ isDisabled: boolean }>`
    ${setFontVariant("listItem3")};
    ${truncateText()};
    color: ${({ isDisabled }) => (isDisabled ? colorsPalettes.midnight[100] : colorsPalettes.carbon[500])};
`;

export const StyledAutocompleteSearch = styled.div`
    transform: translate(0, -100%);

    & > div {
        width: 100%;
    }

    & [data-slot="control"] {
        min-width: 0;
    }
`;

export const StyledAutocompleteIcon = styled(ItemIcon)<{ isDisabled: boolean }>`
    width: 24px;
    height: 24px;
    flex: none;
    background: ${({ isDisabled }) => (isDisabled ? colorsPalettes.bluegrey[200] : colorsPalettes.carbon[0])};
`;

export const StyledPopoverContent = styled(PopoverContent)`
    padding: 0;
    max-height: 250px;
    overflow-y: auto;
    z-index: 1000;
`;
